import VideoPopup, { VideoPopupProps } from "components/VideoPopup";
import { publicUrl } from "config";

type HowItWorksPopupProps = Omit<
  VideoPopupProps,
  "children" | "src" | "isClosable"
>;

const HowItWorksPopup = ({ ...rest }: HowItWorksPopupProps) => (
  <VideoPopup src={`${publicUrl}/connect-video.mp4`} {...rest} />
);

export default HowItWorksPopup;
